///////////////////////////////////////////////////////////////////////////////////////
//                          Copyright (c) 2020 - 2020
//                           Coyote Logistics L.L.C.
//                         All Rights Reserved Worldwide
//
//WARNING:  This program (or document) is unpublished, proprietary
//property of Coyote Logistics L.L.C. and is to be maintained in strict confidence.
//Unauthorized reproduction, distribution or disclosure of this program
//(or document), or any program (or document) derived from it is
//prohibited by State and Federal law, and by local law outside of the U.S.
///////////////////////////////////////////////////////////////////////////////////////

export const getOrdinalNumber = number => {
  const ordinals = ["th", "st", "nd", "rd"];
  const remainder = number % 100;
  const ordinal =
    ordinals[(remainder - 20) % 10] || ordinals[remainder] || ordinals[0];
  return number + ordinal;
};

export default getOrdinalNumber;
